import { webviewOpen } from "@/utils/common";
import "./index.less";
import logoImg from "./assets/logo.png";
import { processOssImage } from "@/utils/image";
import { getBrowserEnv } from "@/utils/tools";

interface Props {
  title: string;
  subTitle?: string;
}

const { isMyApp, isWXApp, isXPApp, isWX } = getBrowserEnv();
// 不在APP/小程序/微信浏览器环境下，统一显示该引导栏
export const isShowOpenBar = !isXPApp && !isWXApp && !isMyApp && !isWX;

const OpenBar = ({ title, subTitle }: Props) => {
  const openInAppWebview = () => {
    const targetUrl = encodeURIComponent(location.href);
    webviewOpen({
      url: targetUrl,
    });
  };

  return (
    <>
      {isShowOpenBar ? (
        <div className="open-bar-wrap">
          <div className="info">
            <img alt="" src={processOssImage(logoImg)} className="logo" />
            <div className="desc">
              <div className="title">{title}</div>
              {!!subTitle && <div className="sub-title">{subTitle}</div>}
            </div>
          </div>
          <div className="open-app-btn" onClick={openInAppWebview}>
            APP打开
          </div>
        </div>
      ) : null}
    </>
  );
};

export default OpenBar;
